// extracted by extract-css-chunks-webpack-plugin
module.exports = {"download-icon":"app-connect-main__download-icon___23wy1","downloadIcon":"app-connect-main__download-icon___23wy1","lead":"app-connect-main__lead___DVX2K","panel-footer":"app-connect-main__panel-footer___2mZvo","panelFooter":"app-connect-main__panel-footer___2mZvo","send-this-page-btn":"app-connect-main__send-this-page-btn___1HqjO","sendThisPageBtn":"app-connect-main__send-this-page-btn___1HqjO"};
    if(module.hot) {
      // 1785787140018
      var cssReload = require("../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  